module.exports = __webpack_public_path__ + "media/Components/fonts/Play-9d4887190881e9da6e47a642e74aa265.ttf";